/**
 * Rótulo da badge de não lidas.
 *
 * Acima do teto o número exato deixa de informar ("237 mensagens" e "500
 * mensagens" levam à mesma ação) e só serve para esticar a badge, então vira
 * "99+". Compartilhado entre ChatItem e GroupItem para os dois não divergirem
 * no teto.
 */
export function formatUnreadCount(count: number | null | undefined, max = 99): string {
    if (!count || count < 0) return '';
    return count > max ? `${max}+` : String(count);
}
